'use client';

import { Box, chakra, Container, Flex, Heading, IconButton } from '@chakra-ui/react';
import Image from 'next/image';
import Link from 'next/link';
import { footer_left_menus, footer_right_menus, social_icons } from './constants';
import { footerStyles } from './footer.styles';

const HorizontalSeparator = chakra('hr', {
   base: {
      borderColor: 'brand',
      my: '6',
      borderTopWidth: '1px',
   },
});

export default function Footer() {
   return (
      <Box as="footer" css={footerStyles.mainBox}>
         <Container css={footerStyles.container}>
            <Flex css={footerStyles.footerBigTextBox}>
               <Heading css={footerStyles.footerBigText} as="h1">
                  Cancard
                  <Box css={footerStyles.footerBigTextImageBox}>
                     <Link passHref href="/">
                        <Image
                           src="/assets/icons/apply.svg"
                           width={168}
                           height={168}
                           style={{ width: '100%', height: '100%' }}
                           alt="apply now"
                        />
                     </Link>
                  </Box>
               </Heading>
            </Flex>
            <Box css={footerStyles.footerLinkContainer}>
               <Box css={footerStyles.footerLinkBox} as="ul">
                  {footer_left_menus.map(item => (
                     <Link key={item.label} href={item.href} passHref>
                        <Box css={footerStyles.footerLinkText} as="li">
                           {item.label}
                        </Box>
                     </Link>
                  ))}
               </Box>
               <Box as="ul" css={footerStyles.footerLinkBox}>
                  {footer_right_menus.map(item => (
                     <Link key={item.label} href={item.href} passHref>
                        <Box css={footerStyles.footerLinkText} as="li">
                           {item.label}
                        </Box>
                     </Link>
                  ))}
               </Box>
            </Box>
            <HorizontalSeparator />
            <Box css={footerStyles.footerLinkContainer}>
               <Box css={footerStyles.footerLinkBox} as="ul">
                  Cancard™ is a trademark of Cancard Ltd.
               </Box>
               <Flex css={footerStyles.socialIconBox}>
                  {social_icons.map(item => (
                     <Link href={item.href} key={item.href}>
                        <IconButton css={footerStyles.socialIconButton}>
                           <item.icon />
                        </IconButton>
                     </Link>
                  ))}
               </Flex>
            </Box>
         </Container>
      </Box>
   );
}
